import timeString from '@/modules/time-string.js'

export default function timeDuration(begin, end) {
  let diff = Math.round(end - begin)

  return timeString(diff)
}
